module.exports = __webpack_public_path__ + "static/img/weather_026.a7655657.svg";